import ActivityDetailsModule from './containers/activityDetailsModule'

export {default as ActivityDetailsModuleLayout} from './components/activityDetailsModuleLayout'

export default ActivityDetailsModule
